// extracted by mini-css-extract-plugin
export default {"ResponderStaff":"responderStaff_ResponderStaff__GZUqO","Table":"responderStaff_Table__hjzzm","Name":"responderStaff_Name__8VfAr","Role":"responderStaff_Role__nk6HZ"};